import { APPLE_STORE_SCANNER_HREF, GOOGLE_PLAY_SCANNER_HREF } from '@/components/download_store_badge/constants';

export const getStoreUrl = (osName: string | undefined): string => {
  switch (osName) {
    case 'iOS':
    case 'Mac OS':
      return APPLE_STORE_SCANNER_HREF;

    default:
      return GOOGLE_PLAY_SCANNER_HREF;
  }
};
